import { render, staticRenderFns } from "./CostBearerEducationStudentDocumentPreview.vue?vue&type=template&id=2c71b379&scoped=true&"
import script from "./CostBearerEducationStudentDocumentPreview.vue?vue&type=script&lang=ts&"
export * from "./CostBearerEducationStudentDocumentPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c71b379",
  null
  
)

export default component.exports